import React, { useState} from "react";
import { useNavigate } from "react-router-dom";
import { postUsuario } from "../../services/apiUsuario";
import { erroToastify} from "../../shared/validacaoToastify";
import { ToastContainer } from "react-toastify";
import { CamposPadroes } from "../../shared/CamposPadroes";
import CamposEndereco from "../../components/camposEndereco/camposEndereco";
import ButtonGroup from "../../components/buttonGroup/buttonGroup";
import { Helmet } from "react-helmet";
import CamposFormulario from "../../components/camposFormulario/camposFormulario";

export default function IncluirUsuario() {
  const navigate = useNavigate();
  const [validacaoAtiva, setValidacaoAtiva] = useState<boolean>(false);
  const [formValues, setFormValues] = useState({
    cdCidade:"",
    nmUsuario: "",
    dsLogin: "",
    nmEmail: "",
    dsSenha: "",
    dsCpf: "",
    dtNascimento: "",
    nmSexo: "",
    dsContato: "",
    dsContatoOpcional: "",
    dsCep: "",
    nmLogradouro: "",
    nrLogradouro: "",
    nmBairro: "",
    nmComplemento: "",
    dmResidencial: false,
    perfil: "",
    cidade: "",
    confirmacaoSenha: "",
  });
  
  const applyTelefoneFormat = (value: string) => {
    const cleanedValue = value.replace(/\D/g, ""); 
    const match = cleanedValue.match(/^(\d{2})(\d{0,5})(\d{0,4})$/); 
    if (match) {
      return `(${match[1]}) ${match[2]}${match[3] ? "-" + match[3] : ""}`; 
    }
    return value; 
  };
  const applyCEPFormat = (value: string) => {
    const cleanedValue = value.replace(/\D/g, ""); 
    const match = cleanedValue.match(/^(\d{5})(\d{0,3})$/);
    if (match) {
      return `${match[1]}${match[2] ? "-" + match[2] : ""}`; 
    }
    return value; 
  };
  const applyCPFFormat = (value: string) => {
    const cleanedValue = value.replace(/\D/g, "").slice(0, 11); 
    return cleanedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };
  const applyMask = (fieldName: string, value: string) => {
    switch (fieldName) {
      case "dsCpf":
        return applyCPFFormat(value);
      case "dsContato":
        return applyTelefoneFormat(value);
      case "dsContatoOpcional":
        return applyTelefoneFormat(value);
      case "dsCep":
        return applyCEPFormat(value);
      default:
        return value;
    }
  };
  const getMaxlength = (fieldName: string) => {
    switch (fieldName) {
      case "dsCpf":
        return 14;
      case "dsContato":
      case "dsContatoOpcional":
        return 15;
      case "dsCep":
        return 10;
      default:
        return Infinity;
    }
  };
  const handleMaskChange = (name: string, value: string) => {
    if (name === "dsCpf") {
      const cleanValue = value.replace(/\D/g, ""); 
      setFormValues({ ...formValues, [name]: cleanValue });
    } else {
      const maskedValue = applyMask(name, value);
      const maxLength = getMaxlength(name);
      if (maskedValue.length <= maxLength) {
        setFormValues({ ...formValues, [name]: maskedValue });
      }
    }
  };
  const handleFieldBlur = (name: string, value: string) => {
    if (name === "dsCpf") {
      const cleanValue = value.replace(/\D/g, "");
      const maskedValue = applyCPFFormat(cleanValue);
      setFormValues({ ...formValues, [name]: maskedValue });
    } else {
      const cleanValue = value.replace(/\D/g, "");
      const maskedValue = applyMask(name, cleanValue);
      const maxLength = getMaxlength(name);
      if (maskedValue.length <= maxLength) {
        setFormValues({ ...formValues, [name]: maskedValue });
      }
    }
  };
  const handleFieldChange = (
    name: string,
    value: string | number | boolean
  ) => {
    setFormValues({ ...formValues, [name]: value });
    setValidacaoAtiva(false);
  };
  const handleNumberChange = (name: string, value: string) => {
    const numericValue = value.replace(/\D/g, "");
    setFormValues({ ...formValues, [name]: numericValue });
    setValidacaoAtiva(false);
  };
  const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const dataPresente = new Date();
    const envioDeDados = {
      nmUsuario: formValues.nmUsuario,
      dsLogin: formValues.dsLogin,
      nmEmail: formValues.nmEmail,
      dsSenha: formValues.dsSenha,
      dsCpf: formValues.dsCpf.replace(/\D/g, "").slice(0, 11),
      dtNascimento: formValues.dtNascimento,
      nmSexo: formValues.nmSexo,
      dsContato: formValues.dsContato.replace(/\D/g, ""),
      dsContatoOpcional: formValues.dsContatoOpcional.replace(/\D/g, ""),
      dsCep: formValues.dsCep.replace(/\D/g, ""),
      nmLogradouro: formValues.nmLogradouro,
      nrLogradouro: formValues.nrLogradouro,
      nmBairro: formValues.nmBairro,
      nmComplemento: formValues.nmComplemento,
      dmResidencial: formValues.dmResidencial,
      cdPerfil: 2,
      cdCidade: formValues.cdCidade ? formValues.cdCidade : 0,
      ...CamposPadroes.toObjeto(
        1,
        1,
        dataPresente.toISOString(),
        dataPresente.toISOString(),
        true
      ),
    };
    if (formValues.dsSenha === formValues.confirmacaoSenha) {
      try {
        
        const response = await postUsuario({ ...envioDeDados });
        
        const successMessage = "O usuário foi incluído com sucesso!";
        navigate(
          `/milshop/login?successMessage=${encodeURIComponent(
            successMessage
          )}`
        );
      } catch (error: any) {
        if (!formValues.dtNascimento) {
          erroToastify("Data de nascimento é um campo obrigatório.");
          setValidacaoAtiva(true);
        } else if (!formValues.nmSexo) {
          erroToastify("Sexo é um campo obrigatório.");
          setValidacaoAtiva(true);
        } else if (!formValues.nrLogradouro) {
          erroToastify("Número é um campo obrigatório.");
          setValidacaoAtiva(true);
        }
        if (error.response.data) {
          erroToastify(error.response.data);
          setValidacaoAtiva(true);
        }
      }
    } else {
      if (formValues.confirmacaoSenha === "") {
        erroToastify("Confirme a senha.");
        setValidacaoAtiva(true);
      } else {
        erroToastify("As senhas não condizem.");
        setValidacaoAtiva(true);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Incluir usuário</title>
      </Helmet>
      <div className="container">
        <div
          className="card bg-light mb-4 shadow p-3 mb-5 rounded"
          style={{ width: "auto", border: "none" }}
        >
          <div className="card-body">
            <div className="container">
              <div className="row align-items-start">
                <CamposFormulario
                  formValues={formValues}
                  validacaoAtiva={validacaoAtiva}
                  handleFieldChange={handleFieldChange}
                  handleMaskChange={handleMaskChange}
                  handleFieldBlur={handleFieldBlur}
                  mostrarSenha={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="card bg-light shadow p-3 mb-1 bg-light rounded"
          style={{ width: "auto", border: "none" }}
        >
          <div className="card-body">
            <div className="container">
              <div className="row align-items-start">
                <CamposEndereco
                  formValues={formValues}
                  validacaoAtiva={validacaoAtiva}
                  handleFieldChange={handleFieldChange}
                  handleMaskChange={handleMaskChange}
                  handleFieldBlur={handleFieldBlur}
                  handleNumberChange={handleNumberChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="row align-items-center">
            <div className="row">
              <div className="col">
                <div className="d-flex justify-content-start">
                  <ButtonGroup handleConfirmar={handleConfirmar} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}
